<template>
  <modal :adaptive="true" :scrollable="true" name="feedback" class="modal-feedback" width="770" height="auto">
    <div class="container">
      <div class="modal-header">
        <div class="modal-header__title">Задайте Ваш вопрос</div>
        <div class="modal-header__subtitle">Заполните форму ниже и мы вышлем ответ в течение 24 часов</div>
        <svg class="close-icon" @click="$modal.hide('feedback')">
          <use xlink:href="#close-black"></use>
        </svg>
      </div>

      <div class="modal-content">
        <form>
          <div class="row">
            <div class="col-md-6 col-sm">
              <input v-model="feedback.first" type="text" class="form-control" placeholder="Ваше имя" required>
            </div>
            <div class="col-md-6 col-sm">
              <input v-model="feedback.last" type="text" class="form-control" placeholder="Ваша фамилия" required>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm">
              <input v-mask="'+7 (###) ###-##-##'" v-model="feedback.phone" type="text" class="form-control"  placeholder="Ваш номер телефона" required @keydown="phoneError = ''">
              <small v-show="phoneError" class="error" v-text="phoneError"></small>
            </div>
            <div class="col-md-6 col-sm">
              <input v-model="feedback.email" type="email" class="form-control success" placeholder="Ваш email" required @keydown="emailError = ''">
              <small v-show="emailError" class="error" v-text="emailError"></small>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <textarea v-model="feedback.messages" class="form-control" rows="4" placeholder="Ваш вопрос" required></textarea>
              <small class="error" v-text="error"></small>
            </div>
          </div>

          <div class="row modal-footer">
            <div class="col-sm col-md-8 custom-checkbox align-self-center">
              <input id="customCheck1" v-model="feedback.confirm" type="checkbox" class="custom-control-input" required>
              <label class="custom-control-label" for="customCheck1">Соглашаюсь с условиями <a href="/privacy.html">обработки персональных данных</a> </label>
            </div>
            <div class="col-sm col-md-4 modal-footer__button">
              <button :disabled="loading" type="submit" class="btn btn-search" @click.prevent="send">Задать вопрос</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>


<script>
import { sendFeedback } from "@/api";

const errorsMap = {
  "phone number length is less than 7": "Слишком короткий номер",
  "phone: invalid - The phone number supplied is not a number.":
    "Неверный номер",
  "email: invalid - mail: no angle-addr": "Невалидный email"
};

const defaultErrorMessage =
  "Произошла ошибка при отправке. Повторите попытку позже.";

export default {
  name: "FeedbackModal",
  data: () => ({
    feedback: {
      first: "",
      last: "",
      phone: "",
      email: "",
      messages: "",
      confirm: false
    },
    emailError: "",
    phoneError: "",
    error: "",
    loading: false
  }),
  mounted() {
    this.$alert.setDefault({ duration: 2000 });
  },
  methods: {
    async send() {
      const isValid = Object.values(this.feedback).every(x => !!x);

      if (!isValid) {
        this.error = "Не все поля заполнены либо не приняты условия";
        return;
      }

      this.loading = true;
      this.resetErrors();

      const response = await sendFeedback(this.feedback);

      if (!response.data.sent && response.error.length) {
        response.error.forEach(err => {
          if (!err.desc.includes("phone") && !err.desc.includes("email")) {
            this.$modal.hide("feedback");
            this.$alert.error({ message: defaultErrorMessage });
          }

          if (err.desc.includes("phone")) {
            this.phoneError = errorsMap[err.desc];
          }

          if (err.desc.includes("email")) {
            this.emailError = errorsMap[err.desc];
          }
        });
      }

      if (response.data.sent) {
        this.$modal.hide("feedback");
        this.$alert.success({ message: "Ваше обращение принято" });
        this.feedback = {};
      }

      this.loading = false;
    },
    resetErrors() {
      this.error = "";
      this.emailError = "";
      this.phoneError = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-feedback {
  .close-icon {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 29px;
    top: 28px;
    cursor: pointer;
  }

  .container {
    padding: 0;
  }
}

.error {
  color: #eb5757;
  padding-left: 2px;
}

.modal-header {
  margin-bottom: 20px;

  &__title {
    font-size: 35px;
    line-height: 41px;
    font-weight: bold;
  }

  &__subtitle {
    font-size: 20px;
    line-height: 23px;
    color: #3b3b3b;
  }
}

.modal-content {
  .row {
    margin-bottom: 15px;
  }
  input,
  textarea {
    border: 1px solid #e5e5e5;
    padding-left: 18px;
    padding-top: 18px;
    padding-bottom: 18px;
    line-height: 19px;
    color: #000;

    &:focus {
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.12);
      border-color: #e5e5e5;
    }

    &:valid {
      border-color: #21b24a;
    }
  }

  textarea {
    resize: none;
    width: 100%;
  }

  .custom-checkbox {
    padding-left: 5px;
    padding-right: 0;

    input[type="checkbox"] {
      opacity: 0;
    }

    input[type="checkbox"] + label::after {
      content: none;
    }

    input[type="checkbox"]:checked + label::after {
      content: "";
    }

    label {
      position: relative;
      display: inline-block;
      padding-left: 45px;
      margin-bottom: 0;
      font-size: 15px;
      color: #3b3b3b;

      &::after,
      &::before {
        position: absolute;
        content: "";
        display: inline-block;
      }

      &::after {
        height: 10px;
        width: 15px;
        border-left: 4px solid #010002;
        border-bottom: 4px solid #010002;

        transform: rotate(-45deg);

        left: 4px;
        top: 4px;
      }

      &::before {
        height: 23px;
        width: 23px;

        border: 1px solid #103677;
        border-radius: 5px;
        left: 0px;
        top: -1px;
      }

      a {
        text-decoration: underline;
        color: #3b3b3b;
      }
    }
  }
}

.modal-footer {
  &__button {
    text-align: right;
    button {
      width: 190px;
    }
  }
}

@include media-breakpoint-down(sm) {
  .modal-feedback {
    .close-icon {
      top: 48px;
    }
  }

  .modal-header {
    &__title {
      font-size: 25px;
      line-height: 29px;
      margin-bottom: 15px;
    }

    &__subtitle {
      font-size: 15px;
      line-height: 18px;
    }
  }

  input {
    margin-bottom: 15px;
  }

  .modal-content {
    .row {
      margin-bottom: 0;
    }

    .custom-checkbox {
      margin-top: 15px;
      padding-left: 15px;
      order: 2;

      input {
        position: absolute;
      }
    }
  }

  .modal-footer {
    margin-top: 18px;
    button {
      width: 100%;
      max-width: 100%;
      height: 58px;
      font-size: 20px;
      line-height: 23px;
      font-weight: bold;
    }
  }
}
</style>
